export const LOGO_URL = "https://customer-assets.emergentagent.com/job_energie-restaurant/artifacts/pi15nzul_MET%20logo%20feher.png";

export const SOUSCRIPTION_URL = "https://souscription.fr.met.com/souscription?utm_source=ads&utm_medium=cpc&utm_campaign=audit";

export const HERO_IMAGE = "https://customer-assets.emergentagent.com/job_energie-restaurant/artifacts/j1z2rnr9_Young%20Happy%20Waitress%20Using%20Touchpad%20While%20Working%20in%20a%20Cafe.%20%282%29.jpg";

export const HERO_CATEGORIES = [
  { label: "Restaurants", icon: "UtensilsCrossed" },
  { label: "Hôtels", icon: "BedDouble" },
  { label: "Cafés & Bars", icon: "Coffee" },
];

export const HERO_STATS = [
  { value: "1 400+", label: "établissements CHR accompagnés", icon: "Building2" },
  { value: "0 €", label: "d'abonnement, sans engagement", icon: "BadgeEuro" },
  { value: "1", label: "seul interlocuteur électricité + gaz", icon: "Plug" },
];

export const COMPANY_STATS = [
  { value: "+10 000", label: "clients actifs en portefeuille", icon: "Users" },
  { value: "68 M€", label: "chiffre d'affaires 2024", icon: "TrendingUp" },
  { value: "89 %", label: "clients prêts à nous recommander", icon: "ThumbsUp" },
  { value: "22 pays", label: "présence européenne via MET Group", icon: "Globe2" },
];

export const PAIN_POINTS = [
  {
    title: "Puissance mal calibrée",
    text: "Une puissance souscrite mal calibrée, ça se paye chaque mois — sans que personne ne vous le signale.",
    icon: "Gauge",
  },
  {
    title: "Contrat dépassé",
    text: "Un contrat signé il y a 18 mois ne correspond peut-être plus à votre profil de consommation.",
    icon: "Clock",
  },
  {
    title: "Sans coupure, sans frais",
    text: "Changer de fournisseur ne coupe jamais le service et ne coûte rien.",
    icon: "ShieldCheck",
  },
  {
    title: "Comparaison indépendante",
    text: "Sans comparaison indépendante, impossible de savoir si vous êtes au bon tarif.",
    icon: "Scale",
  },
];

export const AUDIT_STEPS = [
  {
    n: "01",
    title: "Envoyez votre facture",
    text: "Une simple photo ou PDF de votre dernière facture suffit. Cinq minutes, c'est tout.",
  },
  {
    n: "02",
    title: "Un expert MET l'analyse",
    text: "Notre expert décortique votre contrat : puissance, options tarifaires, profil de consommation.",
  },
  {
    n: "03",
    title: "Vous décidez librement",
    text: "On vous présente nos options, en toute transparence. Aucun engagement, aucune pression.",
  },
];

export const TESTIMONIALS = [
  {
    quote: "L'audit a mis en lumière une anomalie dans notre puissance souscrite. On a ajusté notre contrat rapidement.",
    name: "Marc T.",
    role: "Restaurateur, Lyon",
  },
  {
    quote: "Un seul contact pour l'élec et le gaz, ça change vraiment la vie au quotidien.",
    name: "Sophie L.",
    role: "Hôtelière, Bordeaux",
  },
  {
    quote: "Réactifs et clairs. Aucun jargon. Exactement ce qu'il fallait.",
    name: "Karim B.",
    role: "Gérant de café, Paris",
  },
];

export const ETABLISSEMENT_TYPES = [
  "Restaurant",
  "Hôtel",
  "Café-Bar",
  "Hôtel-Restaurant",
  "Autre",
];
